export const NAV_LINKS = [
  { labelKey: "home" as const, href: "/" },
  { labelKey: "about" as const, href: "/about" },
  { labelKey: "capabilities" as const, href: "/capabilities" },
  { labelKey: "products" as const, href: "/products" },
  { labelKey: "cnc" as const, href: "/cnc" },
  { labelKey: "steel" as const, href: "/steel" },
  { labelKey: "coating" as const, href: "/coating" },
  { labelKey: "catalogs" as const, href: "/catalogs" },
  { labelKey: "gallery" as const, href: "/gallery" },
  { labelKey: "contact" as const, href: "/contact" },
] as const;

export type NavKey = typeof NAV_LINKS[number]["labelKey"];
